var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appMessages"},_vm._l((_vm.messages),function(message,i){return _c('AppMessage',_vm._b({key:i,on:{"dismissed":_vm.dismiss}},'AppMessage',message,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }